import React from "react";

/** Site chrome (navbar/footer) already lives in `App.js`; this matches the Next.js layout slot. */
export default function MainLayout({ children }) {
  return <>{children}</>;
}
